function removeAllButton(event) {
    event.preventDefault();

    let relocateUrl = event.currentTarget.dataset.dropCart,
        actionUrl = event.currentTarget.href;

    $.get(actionUrl, () => {
        window.location.href = relocateUrl;
    });
}


function addToCart() {

    $(document).on('click', '.single_add_to_cart_button', function (e) {
        e.preventDefault();

        let $cartButton = $(this),
            cartButtonHTML = $(this).html(),
            $cartForm = $cartButton.closest('form.cart'),
            id = $cartButton.val(),
            product_qty = $cartForm.find('input[name=quantity]').val() || 1,
            product_id = $cartForm.find('input[name=product_id]').val() || id,
            variation_id = $cartForm.find('input[name=variation_id]').val() || 0;

        let data = {
            action: 'woocommerce_ajax_add_to_cart',
            product_id: product_id,
            product_sku: '',
            quantity: product_qty,
            variation_id: variation_id,
        };

        // $(document.body).trigger('adding_to_cart', [$cartButton, data]);

        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            beforeSend: () => {
                $cartButton.text('Putting to cart...');
                $cartForm.append('<div class="loader-wrapper"><span class="loader"></span></div>');
            },
            complete: () => {
                $cartForm.find('.loader-wrapper').fadeOut(333);
            },
            success: (response) => {
                if (response.error && response.product_url) {
                    window.location = response.product_url;
                } else {
                    // $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $cartButton]);
                    //alert('Added ' + data.quantity + ' product to cart.' );
                }
                $cartButton.text('Added ' + data.quantity + ' product!');
                setTimeout(() => {
                    $cartButton.empty().append(cartButtonHTML);
                }, 2000);
            },
        });

        return false;
    });
}

function handleOptionActive(event) {
    $(event.currentTarget).closest('li').siblings().removeClass('active');
    $(event.currentTarget).closest('li').addClass('active');
    $(event.currentTarget).parent().addClass('active');
}

function init() {
    const cartPage = document.querySelector('.cart-page'),
        checkoutPage = document.querySelector('.cart-page.checkout-page'),
        productPage = document.querySelector('.single-product');

    if (cartPage) {
        $(cartPage).on('click', '[data-drop-cart]', (event) => removeAllButton(event));
    }

    if (checkoutPage) {
        $("#shippingMethod .js-remove").remove();
        setTimeout(() => {
            $('ul.wc_payment_methods').on('click', 'label', (event) => handleOptionActive(event));
            $('ul.woocommerce-shipping-methods label').on('click', (event) => handleOptionActive(event));
        }, 1000);
    }

    if (productPage) {
        addToCart();
    }
}

export default {init};